import { CommonModule } from '@angular/common';
import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'qwiko';
  theme = signal<string>('light');
  themes = ['purple', 'violet', 'dark', 'light'];

  toggleTheme() {
    const randomTheme =
      this.themes[(this.themes.indexOf(this.theme()) + 1) % this.themes.length];
    this.theme.set(randomTheme);
  }
}
